import Base from "./base.js"
export default class MicDisable extends Base {
  constructor() {
    super("mic-disable")
  }
}
